var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nuxt-link', {
    staticClass: "gift-product",
    attrs: {
      "to": _vm.gift.path
    }
  }, [_c('div', {
    staticClass: "gift-product__img-wrap"
  }, [_c('img', {
    staticClass: "gift-product__img",
    attrs: {
      "src": _vm.gift.thumbnail.x1,
      "srcset": ((_vm.gift.thumbnail.x1) + " 1x, " + (_vm.gift.thumbnail.x2) + " 2x"),
      "alt": _vm.gift.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gift-product__text"
  }, [_c('p', {
    staticClass: "gift-product__title"
  }, [_vm._v("\n      В подарок\n      "), _vm.count > 1 ? _c('span', {
    staticClass: "gift-product__title-sup"
  }, [_vm._v("+ " + _vm._s(_vm.count - 1))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "gift-product__name lh-18"
  }, [_vm._v("\n      " + _vm._s(_vm.gift.name) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "gift-product__ribbon"
  }, [_c('img', {
    staticClass: "gift-product__ribbon-img",
    attrs: {
      "src": require("assets/images/gift.png"),
      "srcset": require("assets/images/gift.png") + " 1x, " + require("assets/images/gift@2x.png") + " 2x",
      "alt": "Подарок"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }